import { Body, colors } from '@spritz-finance/ui'
import styled from 'styled-components'
import { ExpandDetailIcon } from '../../../../../../components/ExpandedDetailIcon'
import { Row } from '../../../../../../components/Layout/Row'
import { cssVar } from '../../../../../../theme/utils'

const Container = styled.div`
    position: absolute;
    top: 14px;
    right: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 16px;
    background: var(--surface-3, ${colors.silverGray});
    border-radius: 25px;
    height: 34px;
    padding-right: 7px;
    &:hover {
        cursor: pointer;
    }
`

export const TogglePaymentDetails = ({
    onClick,
    expanded,
}: {
    onClick: () => void
    expanded: boolean
}) => {
    return (
        <Container onClick={onClick}>
            <Row>
                <Body.Med secondary size={14}>
                    Details
                </Body.Med>
                <ExpandDetailIcon
                    size={24}
                    active={expanded}
                    tint={cssVar('--text-secondary', colors.charcoal)}
                />
            </Row>
        </Container>
    )
}
